import { render, staticRenderFns } from "./ModalCampaignTargetingRule.vue?vue&type=template&id=50a9c800&"
import script from "./ModalCampaignTargetingRule.vue?vue&type=script&lang=js&"
export * from "./ModalCampaignTargetingRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports